module.exports = __webpack_public_path__ + "static/img/preview-07.5ea046fd.webp";